// extracted by mini-css-extract-plugin
export var breadcrumb = "_0-3";
export var breadcrumbArrow = "_0-4";
export var breadcrumbs = "_0-0";
export var link = "_0-5";
export var sm = "_0-1";
export var xs = "_0-2";